export default __webpack_public_path__ + "620df5aaedd059a036d52b448521835a.jpg";